import Calendar, { useReactBigCalendar } from "./Calendar";

export { useReactBigCalendar };
export default Calendar;
